"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortAppointmentTypes = exports.getPharmOpenHours = exports.formatOpenCloseHours = exports.hasDistinctCharacters = exports.getAvailableTimes = exports.formatPrice = exports.formatPrescriptionNumber = exports.formatPhoneNumber = void 0;
var date_fns_1 = require("date-fns");
function formatPhoneNumber(phoneNumber) {
    phoneNumber = phoneNumber.replace(/\D/g, "");
    if (phoneNumber.length >= 10) {
        return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
    }
    else if (phoneNumber.length >= 7) {
        return phoneNumber.replace(/(\d{3})(\d{3})(\d*)/, "($1) $2-$3");
    }
    else if (phoneNumber.length >= 4) {
        return phoneNumber.replace(/(\d{3})(\d*)/, "($1) $2");
    }
    return phoneNumber;
}
exports.formatPhoneNumber = formatPhoneNumber;
function formatPrescriptionNumber(prescriptionNumber) {
    prescriptionNumber = prescriptionNumber.replace(/\D/g, "");
    return prescriptionNumber;
}
exports.formatPrescriptionNumber = formatPrescriptionNumber;
function formatPrice(price) {
    var absValue = Math.abs(price);
    var formatted = absValue.toFixed(2);
    return price >= 0 ? "$".concat(formatted) : "($".concat(formatted, ")");
}
exports.formatPrice = formatPrice;
var getDayFromDate = function (selectedDate) {
    var dayCode = selectedDate.getDay();
    switch (dayCode) {
        case 0:
            return "Sunday";
        case 1:
            return "Monday";
        case 2:
            return "Tuesday";
        case 3:
            return "Wednesday";
        case 4:
            return "Thursday";
        case 5:
            return "Friday";
        case 6:
            return "Saturday";
    }
};
function minutesToTimeString(minutes) {
    var formattedHours = Math.floor(minutes / 60)
        .toString()
        .padStart(2, "0");
    var formattedMinutes = (minutes % 60).toString().padStart(2, "0");
    return "".concat(formattedHours, ":").concat(formattedMinutes);
}
function getTimes(openTime, closeTime, interval) {
    var openHour = Number(openTime.slice(0, 2));
    var openMinutes = Number(openTime.slice(3, 5));
    var closeHour = Number(closeTime.slice(0, 2));
    var closeMinutes = Number(closeTime.slice(3, 5));
    var openTotal = openHour * 60 + openMinutes;
    var closeTotal = closeHour * 60 + closeMinutes;
    var times = [];
    for (var currTimeTotal = openTotal; currTimeTotal + interval <= closeTotal; currTimeTotal += interval) {
        times.push(minutesToTimeString(currTimeTotal));
    }
    return times;
}
function addMinutesToTime(time, minutes) {
    var _a = time.split(":"), hoursStr = _a[0], minutesStr = _a[1];
    var parsedHours = parseInt(hoursStr);
    var parsedMinutes = parseInt(minutesStr);
    return minutesToTimeString(parsedHours * 60 + parsedMinutes + minutes);
}
function convertToNextHalfHourInterval(dateToConvert) {
    var currentMinutes = dateToConvert.getMinutes();
    if (currentMinutes === 0 || currentMinutes === 30) {
        return dateToConvert;
    }
    var minutesToAdd = currentMinutes < 30 ? 30 - currentMinutes : 60 - currentMinutes;
    return (0, date_fns_1.add)(dateToConvert, { minutes: minutesToAdd });
}
function getDifferenceInMinutesBasedOnPharmacyHours(now, selectedDayWithOpenTime, pharmacyHours) {
    var iterationDate = now;
    var diffInMinutes = 0;
    while ((0, date_fns_1.isBefore)(iterationDate, selectedDayWithOpenTime)) {
        var iterationDateHours = pharmacyHours.find(function (listedDay) { return getDayFromDate(iterationDate) === listedDay.day; });
        if (!iterationDateHours) {
            iterationDate = (0, date_fns_1.addDays)(iterationDate, 1);
            continue;
        }
        var iterationDateWithCloseTime = (0, date_fns_1.parse)(iterationDateHours.close, "HH:mm:ss", iterationDate);
        if ((0, date_fns_1.isAfter)(now, iterationDateWithCloseTime)) {
            iterationDate = (0, date_fns_1.addDays)(iterationDate, 1);
            continue;
        }
        var iterationDateWithOpenTime = (0, date_fns_1.parse)(iterationDateHours.open, "HH:mm:ss", iterationDate);
        var startTime = (0, date_fns_1.isAfter)(now, iterationDateWithOpenTime)
            ? now
            : iterationDateWithOpenTime;
        diffInMinutes += (0, date_fns_1.differenceInMinutes)(iterationDateWithCloseTime, startTime);
        iterationDate = (0, date_fns_1.addDays)(iterationDate, 1);
    }
    return diffInMinutes;
}
function getAvailableTimes(date, pharmacyHours, leadBufferMinutes, closingBufferMinutes) {
    if (leadBufferMinutes === void 0) { leadBufferMinutes = 0; }
    if (closingBufferMinutes === void 0) { closingBufferMinutes = 0; }
    if (!pharmacyHours) {
        return [];
    }
    var day = getDayFromDate(date);
    var selectedDays = pharmacyHours.filter(function (d) { return d.day === day; });
    var invalidDays = selectedDays.filter(function (d) { return d.open > d.close; });
    if (!selectedDays.length || invalidDays.length) {
        return [];
    }
    var times = [];
    for (var i = 0; i < selectedDays.length; i++) {
        var selectedDay = selectedDays[i];
        var open = selectedDay.open;
        var now = new Date();
        var nextHalfHourIntervalAfterNow = convertToNextHalfHourInterval(now);
        var remainingLeadBufferMinutes = leadBufferMinutes;
        if ((0, date_fns_1.isSameDay)(date, now)) {
            open = (0, date_fns_1.format)(nextHalfHourIntervalAfterNow, "HH:mm");
        }
        else {
            var selectedDayWithOpenTime = (0, date_fns_1.parse)(selectedDay.open, "HH:mm:ss", date);
            var minutesPassedBetweenNowAndSelectedDateOpenTime = getDifferenceInMinutesBasedOnPharmacyHours(now, selectedDayWithOpenTime, pharmacyHours);
            remainingLeadBufferMinutes =
                remainingLeadBufferMinutes >
                    minutesPassedBetweenNowAndSelectedDateOpenTime
                    ? remainingLeadBufferMinutes -
                        minutesPassedBetweenNowAndSelectedDateOpenTime
                    : 0;
        }
        var intervalMinutes = 30;
        var openBuffer = Math.ceil(remainingLeadBufferMinutes / intervalMinutes) * intervalMinutes;
        var closeBuffer = Math.ceil(closingBufferMinutes / intervalMinutes) * intervalMinutes;
        var newTimes = getTimes(addMinutesToTime(open, openBuffer), addMinutesToTime(selectedDay.close, -closeBuffer), intervalMinutes);
        times.push.apply(times, newTimes);
    }
    return times;
}
exports.getAvailableTimes = getAvailableTimes;
// android doesn't support negtive lookbehinds in regex
function hasDistinctCharacters(minNumDistinctChars, str) {
    if (str.length < minNumDistinctChars) {
        return false;
    }
    var uniqueChars = 0;
    var letters = {};
    var i = 0;
    while (uniqueChars < minNumDistinctChars && i < str.length) {
        var letter = str[i];
        if (!letters[letter]) {
            letters[letter] = true;
            uniqueChars++;
        }
        i++;
    }
    return uniqueChars >= minNumDistinctChars;
}
exports.hasDistinctCharacters = hasDistinctCharacters;
var WEEKDAYS = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
];
var WEEKDAYS_SPANISH = [
    "Domingo",
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
];
function formatOpenCloseHours(openTime, closeTime) {
    var openTimeDate = (0, date_fns_1.parse)(openTime, "HH:mm:ss", new Date());
    var closeTimeDate = (0, date_fns_1.parse)(closeTime, "HH:mm:ss", new Date());
    var formattedHourStr = "".concat((0, date_fns_1.format)(openTimeDate, "p"), "-").concat((0, date_fns_1.format)(closeTimeDate, "p")).toLowerCase();
    var pattern = /(:00)|(\s)/g;
    return formattedHourStr.replace(pattern, "");
}
exports.formatOpenCloseHours = formatOpenCloseHours;
function getPharmOpenHours(now, hours, baseUtcOffset) {
    var currentDayIndex = now.getDay();
    var weekDay = WEEKDAYS[currentDayIndex];
    var weekDaySpanish = WEEKDAYS_SPANISH[currentDayIndex];
    var hoursMatchingDay = hours.filter(function (h) { return h.day === weekDay || h.day === weekDaySpanish; });
    if (hoursMatchingDay.length === 0) {
        return { isOpen: false, currentlyOpenHours: null };
    }
    for (var i = 0; i < hoursMatchingDay.length; i++) {
        var openingDate = (0, date_fns_1.parse)(hoursMatchingDay[i].open + baseUtcOffset, "HH:mm:ssXXXXX", now);
        var closingDate = (0, date_fns_1.parse)(hoursMatchingDay[i].close + baseUtcOffset, "HH:mm:ssXXXXX", now);
        var isOpen = ((0, date_fns_1.isAfter)(now, openingDate) || (0, date_fns_1.isEqual)(now, openingDate)) &&
            ((0, date_fns_1.isBefore)(now, closingDate) || (0, date_fns_1.isEqual)(now, closingDate));
        if (isOpen) {
            return {
                isOpen: true,
                currentlyOpenHours: formatOpenCloseHours(hoursMatchingDay[i].open, hoursMatchingDay[i].close),
            };
        }
    }
    return { isOpen: false, currentlyOpenHours: null };
}
exports.getPharmOpenHours = getPharmOpenHours;
function sortAppointmentTypes(selectableAppointmentTypes) {
    // sort appt types so it's always [vaccination, test, consultation]
    return __spreadArray([], selectableAppointmentTypes, true).sort(function (a, b) {
        if (a === "Vaccination") {
            return -1;
        }
        else if (a === "Consultation") {
            return 1;
        }
        else if (a === "Test" && b === "Vaccination") {
            return 1;
        }
        else if (a === "Test" && b === "Consultation") {
            return -1;
        }
        else {
            return 0;
        }
    });
}
exports.sortAppointmentTypes = sortAppointmentTypes;
